import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, Divider, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';


export type MediaPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  mediaSrc: string;
  mediaTitle: string;
  description?: string;
  mediaType?: 'photo' | 'video';
};

// TODO: Refactor the jinja macro for "History" page (FileUploadField/PhotoTakerField) to also use this one for visual conformity.
export const MediaPreviewModal = ({
  isOpen,
  onClose,
  mediaSrc,
  mediaType,
  mediaTitle,
  description,
}: MediaPreviewModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth={false} PaperProps={{ sx: { width: '90vw', height: '90vh', borderRadius: '16px' } }}>
      <Stack direction='row' justifyContent='space-between'>
        <Stack sx={{ py: 2 }}>
          <Typography variant='h6' color='primary' sx={{ px: 2 }}>
            {mediaTitle}
          </Typography>
          <Typography variant='body2' color='textSecondary' sx={{ px: 2 }}>
            {description}
          </Typography>
        </Stack>
        <IconButton onClick={onClose} sx={{ color: (theme) => theme.palette.grey[800], mr: 2, alignSelf: 'center' }}>
          <CloseIcon sx={{ fontSize: '36px', fontWeight: 900 }} />
        </IconButton>
      </Stack>
      <Divider />
      <Box sx={{ m: 1, display: 'flex', justifyContent: 'center', flex: 1, overflow: 'hidden', backgroundColor: 'black', borderRadius: '8px' }}>
        {mediaType === 'photo' && <img src={mediaSrc} alt='Preview' style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}
        {mediaType === 'video' && <video src={mediaSrc} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}
      </Box>
    </Dialog>
  );
};
